import { domQuerySelector } from 'pf-frontend-common/src/helper/dom/query-selector';

import { configGetSettings } from 'common/helper/config/get-settings';
import { AbTestService } from 'common/service/ab-test/service';
import { FooterService } from 'common/service/footer/service';
import { HeaderService } from 'common/service/header/service';
import { LanguageSelectorService } from 'common/service/language-selector/service';
import { LocationStoreService } from 'common/service/location-store/service';
import { PrivacyPromptService } from 'common/service/privacy-prompt/service';
import { UserAuthenticationService } from 'common/service/user-authentication/service';
import { BuildingReviewBundleSettingsInterface } from 'desktop/entry/building-review/bundle/settings.interface';
import { BuildingReviewPageViewFactory } from 'desktop/module/building-review/page/view.factory';
import { UserAvatarComponent } from 'desktop/module/user/avatar/component';

AbTestService().initialize();

const bundleSettings = configGetSettings<BuildingReviewBundleSettingsInterface>();

// Common services
HeaderService()
  .setComponents({
    UserAvatarComponent,
  })
  .render();
UserAuthenticationService();
FooterService();

LanguageSelectorService();

PrivacyPromptService();

// Initialize stores
const locationStoreService = LocationStoreService();

locationStoreService.initialize({
  payload: bundleSettings.location.payload,
});

// Initialize model
const locationModel = locationStoreService.getOneById(bundleSettings.location.id);

// Initialize view
const view = BuildingReviewPageViewFactory();

view.initialize({
  element: domQuerySelector(document, '[data-qs="building-review"]'),
  locationModel,
  subview: {
    map: {
      viewOptions: {
        element: domQuerySelector(document, '[data-qs="map"]'),
        showOnPageLoad: true,
        settings: {
          showInFullScreen: false,
          interactive: true,
          center: {
            coordinates: locationModel.coordinates,
          },
          zoom: {
            percentage: 78,
            zoomOnScroll: false,
          },
          streetview: true,
          fullscreen: true,
          showTypesControl: true,
          dragPan: false,
          doubleClickZoom: false,
        },
      },
    },
  },
  buildingSpecialist: {
    agentSwitch: domQuerySelector(document, '[data-qs="agent-switch"]'),
    switch: domQuerySelector(document, '[data-qs="switch"]'),
    rent: domQuerySelector(document, '[data-qs="agent-rent"]'),
    sale: domQuerySelector(document, '[data-qs="agent-sale"]'),
  },
});

// Render view
view.render();
